import React from 'react';
import classNames from 'classnames';
import './styles.scss';

export type ItemType = {
  label: string;
  onClick?: any;
};

interface Props {
  items: Array<ItemType>;
}

const BreadcrumbUI: React.FC<Props> = ({ items }) => (
  <div className="breadcrumbs">
    {items.map((item: ItemType, index) => {
      const titleClassName = classNames({
        title: true,
        pointer: item.onClick
      });
      return (
        <React.Fragment key={index}>
          {index > 0 && <div className="separator">/</div>}
          <div className={titleClassName} onClick={() => item.onClick && item.onClick()}>
            {item.label}
          </div>
        </React.Fragment>
      );
    })}
  </div>
);

export default BreadcrumbUI;
